var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h2", [_vm._v("图表结构")]),
      _vm._v(" "),
      _c("p", [_vm._v("图表由 chart、visual、plugin 组成")]),
      _vm._v(" "),
      _c("p", { attrs: { align: "center" } }, [
        _c("img", {
          attrs: {
            src: "http://p6.qhimg.com/t0137055a27f367470b.png",
            alt: "chart-structure",
            height: "400"
          }
        })
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("绘制图表")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("绘制图表与添加插件的方法均为："),
        _c("code", { pre: true }, [
          _vm._v("chart.append(/* visual 实例 或者 plugin 实例 */)")
        ]),
        _vm._v("。")
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" data = [\n  { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("date")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'05-01'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("catgory")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'图例一'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("sales")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("15.2")
            ]),
            _vm._v(" },\n  { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("date")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'05-02'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("catgory")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'图例一'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("sales")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("39.2")
            ]),
            _vm._v(" },\n  { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("date")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'05-03'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("catgory")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'图例一'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("sales")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("31.2")
            ]),
            _vm._v(" },\n  { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("date")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'05-04'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("catgory")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'图例一'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("sales")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("65.2")
            ]),
            _vm._v(" },\n  { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("date")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'05-05'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("catgory")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'图例一'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("sales")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("55.2")
            ]),
            _vm._v(" }\n]\n\n"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" { Chart, Line, Legend, Tooltip, Axis } = qcharts\n"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" chart = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Chart({\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("container")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'#app'")
            ]),
            _vm._v("\n})\nchart.source(data, {\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("row")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'catgory'")
            ]),
            _vm._v(",\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("value")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'sales'")
            ]),
            _vm._v(",\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("text")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'date'")
            ]),
            _vm._v("\n})\n"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" line = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Line()\n"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" axisBottom = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Axis().style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'grid'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-literal" } }, [
              _vm._v("false")
            ]),
            _vm._v(")\n"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" toolTip = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Tooltip()\n"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" legend = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Legend()\n"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" axisLeft = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Axis({ "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("orient")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'left'")
            ]),
            _vm._v(
              " })\n\nchart.append([line, axisBottom, axisLeft, toolTip, legend])\n"
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("在 "),
        _c("code", { pre: true }, [_vm._v("qcharts")]),
        _vm._v(" 中将传统的图表类型（如："),
        _c("code", { pre: true }, [_vm._v("pie")]),
        _vm._v(" 和 "),
        _c("code", { pre: true }, [_vm._v("line")]),
        _vm._v("）区分为 "),
        _c("code", { pre: true }, [_vm._v("visual")]),
        _vm._v("，意为一种可视类型。可以在一个 "),
        _c("code", { pre: true }, [_vm._v("chart")]),
        _vm._v(" 传入多个 "),
        _c("code", { pre: true }, [_vm._v("visual")]),
        _vm._v(" 实例。")
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("数据更新")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("在 "),
        _c("code", { pre: true }, [_vm._v("qcharts")]),
        _vm._v(" 如果数据存在更新，可以直接更新数据，如下：")
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _vm._v("chart.source(newData, {\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("row")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'catgory'")
            ]),
            _vm._v(",\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("value")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'value'")
            ]),
            _vm._v(",\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("text")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'text'")
            ]),
            _vm._v("\n})\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("如果更新的数据中，对应的字段名称都没有改变，直接")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [_vm._v("chart.source(newData)\n")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }